import { createSlice } from "@reduxjs/toolkit";
import { Root } from "../../roots/models/Root";

const DressCacheInitialState: {
	roots: Root[];
} = {
	roots: [],
};

export const DressCacheReducer = createSlice({
	name: "__",
	initialState: DressCacheInitialState,
	reducers: {
		setRoots(state, { payload }) {
			state.roots = payload;
		},
	},
});
